






















import { Component, Inject, Vue } from "vue-property-decorator";
@Component
export default class InvoiceDuplicatedMsg extends Vue {
  // Injects
  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider;
  // Computed
  public get $invoice() {
    return this.$invoiceProvider();
  }
}
